import { Chapter, LearningModuleCertification, LearningModuleContentsEntry } from 'types/learningHub/moduleContents';
import { CertificationTest } from 'types/module';

export const getInitialSelectedEntry = (chapters: Chapter[]) => ({ ...chapters[0]?.lessons[0], chapterId: chapters[0]?.id });

export const getSelectedLessonsChapterId = (chapters: Chapter[], selectedLessonId: string) =>
  chapters.find((chapter) => chapter.lessons.some((lesson) => lesson.id === selectedLessonId))?.id ?? '';

export const getSelectedChapter = (chapters: Chapter[], selectedEntryChapterId: string) =>
  chapters.find((c) => c.id === selectedEntryChapterId);

export const getSelectedLesson = (chapters: Chapter[], selectedLessonId: string) =>
  chapters.flatMap((chapter) => chapter.lessons).find((l) => l.id === selectedLessonId);

export const getSelectedEntry = (
  chapters: Chapter[],
  certifications: LearningModuleCertification[],
  selectedEntryId: string
): LearningModuleContentsEntry =>
  [...chapters.flatMap((chapter) => chapter.lessons.map((lesson) => ({ ...lesson, chapterId: chapter.id }))), ...certifications].find((entry) => entry.id === selectedEntryId)!;

export const getLessonHeader = (chapters: Chapter[], lessonId: string): { header: string; subheader: string } => {
  const lessonChapterId = getSelectedLessonsChapterId(chapters ?? [], lessonId ?? '');
  const chapter = getSelectedChapter(chapters ?? [], lessonChapterId ?? '');
  const header = chapter && chapters ? `${chapters.indexOf(chapter) + 1}. ${chapter.title ?? ''}` : '';
  const subheader = getSelectedLesson(chapters ?? [], lessonId ?? '')?.title ?? '';
  return { header, subheader };
};

export const getCertificationDescription = (certifications: CertificationTest[], selectedCertificationId: string): string => {
  return certifications.find((c) => c.id === selectedCertificationId)?.description ?? '';
};

export const isLessonEntry = (entry: LearningModuleContentsEntry): boolean => entry.type === 'lesson';

export const isChapterTestEntry = (entry: LearningModuleContentsEntry): boolean => entry.type === 'chapterTest';

export const isCertificationEntry = (entry: LearningModuleContentsEntry): boolean => entry.type === 'certificate';
